import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ModeCommentIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mode_comment"}/>
}
